package com.eladfinish.bible.contest.screens.browse.usecases.shonot

import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ShonotEntry
import com.eladfinish.bible.contest.ui.models.ChapterTextAlign

/** The text of an entry of the "שונות" tab, shown as a part of the chapter screen. */
class GetShonotContentUseCase(
    private val shonotUseCaseProvider: ShonotUseCaseProvider,
) {
    /** [deceasedName] is needed by [ShonotEntry.TEHILIM119] only, whose verses spell it. */
    operator fun invoke(entry: ShonotEntry, deceasedName: String?): ChapterData {
        val content = when (entry) {
            ShonotEntry.ROSH_CHODESH -> shonotUseCaseProvider.getRoshChodeshContentUseCase()
            ShonotEntry.TAANIT_TZIBUR -> shonotUseCaseProvider.getTaanitTziburContentUseCase()
            ShonotEntry.TEHILIM119 -> shonotUseCaseProvider.getTehilim119UseCase(deceasedNameOriginal = requireNotNull(deceasedName))
            ShonotEntry.TIQUN_HAKLALI -> shonotUseCaseProvider.getTiqunHaklaliUseCase()
            ShonotEntry.PARASHAT_HAMAN -> shonotUseCaseProvider.getParashatHaManContentUseCase()
        }
        return ChapterData(
            content = content,
            spannedRangeList = shonotUseCaseProvider.makeOtiotPasukSmallerUseCase(charSequence = content),
            // Tehilim 119 is laid out in columns, which justifying would break.
            textAlign = if (entry == ShonotEntry.TEHILIM119) null else ChapterTextAlign.JUSTIFY,
        )
    }
}
